module.exports = __webpack_public_path__ + "static/media/IAP_Whole@3x.c5950159.png";